import classNames from 'classnames';
import type React from 'react';
import type { PropsWithChildren } from 'react';
import { Alert } from 'reactstrap';
import existingIcons from 'src/assets/icons/DsIcons';
import AuthCopyright from './AuthCopyright';
import AuthHeader from './AuthHeader';

interface Props extends PropsWithChildren {
  headerText: string;
  showAlert?: boolean;
  alertType?: 'success' | 'error';
  alertMessage?: string;
}

const alertIconMap = {
  success: existingIcons.circle_tick_icon_green,
  error: existingIcons.circle_close_icon_red,
};

const AuthCard: React.FC<Props> = ({
  children,
  headerText,
  showAlert = false,
  alertType = 'success',
  alertMessage = '',
}) => (
  <div className="auth-card" data-testid="auth-card">
    <div className="ls-card">
      <AuthHeader headerText={headerText} />
      {showAlert && (
        <Alert
          className={classNames('ls-alert', 'close-none', {
            'ls-alert--success': alertType === 'success',
            'ls-alert--danger': alertType === 'error',
          })}
          toggle={() => {}}
          data-testid={`auth.${alertType}-alert`}
        >
          <div className="ls-icon has-md">{alertIconMap[alertType ?? 'success']}</div>
          <div className="ls-alert-content">
            <div className="body-sm">{alertMessage}</div>
          </div>
        </Alert>
      )}
      {children}
    </div>
    <AuthCopyright />
  </div>
);

export default AuthCard;
